import { logger } from '@damofire/data-commons';
import { Observer, Subject } from 'rxjs';
import { WarehouseSyncStepContext, WarehouseSyncStepContextEvent, WarehouseSyncStepTaskContext } from './executors';

export class WarehouseSyncStepStatusListenerProxy implements Observer<WarehouseSyncStepContextEvent> {
  closed: boolean;

  constructor(private readonly delegate: Subject<WarehouseSyncStepContextEvent>) {}

  next(event?: WarehouseSyncStepContextEvent): void {
    this.handleEvent(event).then(() => {
      this.delegate.next(event);
    });
  }

  complete(): void {
    this.delegate.complete();
    this.closed = true;
  }

  error(err: unknown): void {
    this.delegate.error(err);
  }

  private async handleEvent(event: WarehouseSyncStepContextEvent): Promise<void> {
    switch (event.event) {
      case 'TASK_PROGRESSED':
        this.onTaskProgress(event.ctx as WarehouseSyncStepTaskContext);
        break;
      case 'TASK_FINISHED':
        this.onTaskFinished(event.ctx as WarehouseSyncStepTaskContext);
        break;
      case 'TASK_ERROR':
        this.onTaskError(event.ctx as WarehouseSyncStepTaskContext, event.err);
        break;
      case 'STEP_PROGRESS':
        this.onStepProgress(event.ctx as WarehouseSyncStepContext);
        break;
      case 'STEP_FINISHED':
        this.onStepFinished(event.ctx as WarehouseSyncStepContext);
        break;
      case 'STEP_ERROR':
        this.onStepError(event.ctx as WarehouseSyncStepContext, event.err);
        break;
      case 'SYNC_CANCELLED':
        this.onSyncCancelled(event.ctx.division);
        break;
      case 'TASK_STARTED':
        this.onTaskStarted(event.ctx as WarehouseSyncStepTaskContext);
        break;
      case 'STEP_CANCELLED':
        this.onStepCancelled(event.ctx.division);
        break;
      case 'SYNC_FINISHED':
        this.onSyncFinished(event.ctx.division);
        break;
      default:
        logger.error('Something went wrong with sync, unknown event received', { event: event.event, category: 'sync' });
    }
  }

  onStepError(ctx: WarehouseSyncStepContext, err: unknown): void {
    logger.error('WarehouseSyncStepStatusListenerProxy::onStepError', { division: ctx.division, step: ctx.step, task: ctx.task, error: err, category: 'sync' });
  }

  onStepFinished(ctx: WarehouseSyncStepContext): void {
    logger.info('WarehouseSyncStepStatusListenerProxy::onStepFinished', { division: ctx.division, step: ctx.step, task: ctx.task, category: 'sync' });
  }

  onStepProgress(ctx: WarehouseSyncStepContext): void {
    // console.log(`WarehouseSyncStepStatusListenerProxy::onStepProgress`, ctx.division, ctx.step, ctx.task);
  }

  onStepCancelled(warehouse: string): void {
    logger.info('WarehouseSyncStepStatusListenerProxy::onStepCancelled', { warehouse, category: 'sync' });
  }

  onSyncCancelled(warehouse: string): void {
    logger.info('WarehouseSyncStepStatusListenerProxy::onSyncCancelled', { warehouse, category: 'sync' });
  }

  onSyncFinished(warehouse: string): void {
    logger.info('WarehouseSyncStepStatusListenerProxy::onSyncFinished', { warehouse, category: 'sync' });
  }

  onTaskError(ctx: WarehouseSyncStepTaskContext, err: unknown): void {
    logger.error('WarehouseSyncStepStatusListenerProxy::onTaskError', { division: ctx.division, step: ctx.step, task: ctx.task, error: err, category: 'sync' });
  }

  onTaskStarted(ctx: WarehouseSyncStepTaskContext): void {
    // console.error(`WarehouseSyncStepStatusListenerProxy::onTaskStarted`, ctx.division, ctx.step, ctx.task);
  }

  onTaskFinished(ctx: WarehouseSyncStepTaskContext): void {
    // console.log(`WarehouseSyncStepStatusListenerProxy::onTaskFinished`, ctx.division, ctx.step, ctx.task);
  }

  onTaskProgress(ctx: WarehouseSyncStepTaskContext): void {
    // console.log(`WarehouseSyncStepStatusListenerProxy::onTaskProgress`, ctx.division, ctx.step, ctx.task);
  }
}
